// extracted by mini-css-extract-plugin
export default {"derived-view":"DerivedViews_derived-view__MI-rd","derived-view-header":"DerivedViews_derived-view-header__Ezvho","title":"DerivedViews_title__L0Kx-"};